export class Station {
  id: string;
  name: string;
  address: string;
  postcode: string;
  state: string;
  companyId: string;
  companyName: string;

  constructor(
    id: string,
    name: string,
    address: string,
    postcode: string,
    state: string,
    companyId: string,
    companyName: string
  ) {
    this.id = id;
    this.name = name;
    this.address = address;
    this.postcode = postcode;
    this.state = state;
    this.companyId = companyId;
    this.companyName = companyName;
  }
}
